<div class="flex min-w-0 items-center gap-2.5">
  <div
    class="flex shrink-0 items-center"
    data-testid="slot-bar"
    [attr.aria-hidden]="hasClickableSlots() ? null : 'true'"
    [class.h-4]="size() === 'regular'"
    [class.h-3]="size() === 'thin'"
    [style.gap.px]="gap"
    [style.width.px]="layout().barWidth"
  >
    @for (slot of slots(); track $index) {
      @if (slot.clickable) {
        <button
          type="button"
          class="slot-bar-button flex h-full shrink-0 items-center"
          data-testid="slot-bar-block"
          [attr.data-tone]="slot.tone"
          [attr.aria-label]="slot.tooltip ?? null"
          [style.width.px]="layout().blockWidth"
          [matTooltip]="slot.tooltip ?? ''"
          [matTooltipPosition]="tooltipPosition()"
          [matTooltipDisabled]="!slot.tooltip"
          (click)="slotClick.emit($index)"
        >
          <span
            class="slot-bar-fill"
            data-testid="slot-bar-fill"
            [class.is-thin]="size() === 'thin'"
            [style.background]="getBarToneBackground(slot.tone)"
          ></span>
        </button>
      } @else {
        <span
          class="flex h-full shrink-0 items-center"
          data-testid="slot-bar-block"
          [attr.data-tone]="slot.tone"
          [style.width.px]="layout().blockWidth"
          [matTooltip]="slot.tooltip ?? ''"
          [matTooltipPosition]="tooltipPosition()"
          [matTooltipDisabled]="!slot.tooltip"
        >
          <span
            class="slot-bar-fill"
            data-testid="slot-bar-fill"
            [class.is-thin]="size() === 'thin'"
            [style.background]="getBarToneBackground(slot.tone)"
          ></span>
        </span>
      }
    }
  </div>

  <ng-content />
</div>
